// extracted by mini-css-extract-plugin
export default {"contentBox":"ContentBox__contentBox-fUS46","informationHeader":"ContentBox__informationHeader-PlFWj","additionalInformation":"ContentBox__additionalInformation-L_XVB"};